export default "__VITE_ASSET__4548d2ba__"